import React from 'react';
import Select from 'react-select';
import { Button, Glyphicon } from 'react-bootstrap';

class ArrowCombo extends React.Component {
	constructor(props) {
		super(props);

		this.state = this._buildState(props);
	}

	// Public API
	setValue = (value) => {
		//this._update(value, this._parse(value), this._format(value));
	}

	getValue = () => {
		return this.state.value;
	}

	focus = () => {
		this._input.focus();
	}

	select = () => {
		this._input.select();
	}

	flag = (status) => {
		if (!status)
			this.setState((prevState) => {
				return { className: prevState.className + " invalid-field" }
			});
		else
			this.setState((prevState) => {
				return { className: prevState.className.replace("invalid-field", "") }
			});
	}

	validate = () => {
		return null;
	}

	completed = () => {
		return !((this.state.value === "" || this.state.value === null) && this.props.required)
	}

	// Events
	onDirt = (e) => {
		this.props.onDirt && this.props.onDirt();
	}

	onChange = (value) => {
		this.props.onChange && this.props.onChange(value);
	}

	// Private
	_buildState = (props) => {
		let state =
			{
				className: this._className(),
				value: props.value,
				text: props.text,
				options: this._getOptions(props.items)
			};

		// If a value is coming in (either at ctor or when updating props), but no text...
		// then look for the text label on the items, to show on the dropdown as well.
		if (props.text === undefined || props.text === null || props.text === "") {
			try {
				state = {
					...state,
					className: this._className(),
					value: props.value,
					text: props.text || state.options.filter(o => { return o.value === props.value })[0].label
				}
			}
			catch (e) {
				if (props.value !== undefined &&
					props.value !== null &&
					props.value !== "") {
					console.error("PSX: ArrowCombo was assigned a value that doesn't exists within the list of available items, and no text was provided either.");
				}
			}
		}

		return state;
	}

	_getOptions = (items) => {
		// It's an array coming, return that one..
		if (items instanceof Array)
			return items;

		let options = [];

		for (var c in items)
			options.push({
				value: c,
				label: items[c]
			});

		return options;
	}

	_handleChange = (item) => {
		const me = this;
		let value = null;
		let label = null;

		if (item !== null) {
			value = item.value;
			label = item.label;
		}

		// In this case, we don't use update (can't remember why)
		this.setState({
			value: value,
			text: label
		}, function () {
			const requiredPassed = this.completed();
			const validationPassed = (this.validate() === null);

			const status = requiredPassed && validationPassed;

			this.flag(status);
			this.onDirt();
			this.onChange(item);

			// Update value field in form
			if (me.props.managed)
			{
				if (!me.props.label)
					this.props.onFieldChange(value, this.props.name, function () { me.onChange(item); });
				else
					this.props.onFieldAndLabelChange(value, label, me.props.name, this.props.label, function () { me.onChange(item); });
			}
		});
	}

	_handlePreviousClick = () => {
		const selectedValue = this.state.value;
		const selectedOption = this.state.options.find(o => o.value === selectedValue);
		const selectedIndex = this.state.options.indexOf(selectedOption);

		if (selectedIndex !== -1) {
			let newValue = this.state.value;
			let newText = this.state.text;

			if (selectedIndex > 0) {
				newValue = this.state.options[selectedIndex - 1].value;
				newText = this.state.options[selectedIndex - 1].label;
			}

			this._handleChange({
				value: newValue,
				label: newText
			});
		}
	}

	_handleNextClick = () => {
		const selectedValue = this.state.value;
		const selectedOption = this.state.options.find(o => o.value === selectedValue);
		const selectedIndex = this.state.options.indexOf(selectedOption);

		if (selectedIndex !== -1) {
			let newValue = this.state.value;
			let newText = this.state.text;

			if (selectedIndex < (this.state.options.length - 1)) {
				newValue = this.state.options[selectedIndex + 1].value;
				newText = this.state.options[selectedIndex + 1].label;
			}

			this._handleChange({
				value: newValue,
				label: newText
			});
		}
	}

	_className = () => {
		if (this.props.className !== undefined)
			return this.props.className;
		else
			return "";
	}

	// React
	shouldComponentUpdate(nextProps, nextState) {
		return (
			nextProps.value !== this.props.value
			|| nextState.value !== this.state.value
			|| nextProps.items !== this.props.items
			|| nextState.className !== this.state.className);
	}

	componentWillReceiveProps(nextProps, nextState) {
		if (nextProps.value !== this.props.value ||
			nextProps.items !== this.props.items)
			this.setState(this._buildState(nextProps));
	}

	render() {
		let value = {
			value: this.state.value,
			label: this.state.text
		};
		// Empty string or null selections? Then leave NULL so the place holder appears...
		if ((value.value === "" || value.value === null || value.value === undefined) &&
			(value.label === "" || value.label === null || value.label === undefined))
			value = null;

		let selectOpts = {
			name: this.props.name,
			value: value,
			placeholder: this.props.placeholder,
			options: this.state.options,
			className: this.state.className,
			onChange: this._handleChange,
			isDisabled: this.props.disabled,
			isSearchable: this.props.searchable,
			isClearable: this.props.clearable
		};

		let buttonOpts = {
			disabled: this.props.disabled
		};

		const customStyles = {
			input: (provided, state) => ({
				...provided,
				margin: 0,
				paddingBottom: 0,
				paddingTop: 0
			}),
			indicatorSeparator: (provided, state) => ({
				...provided,
				width: 0
			}),
			indicatorContainer: (provided, state) => ({
				...provided,
				cursor: 'pointer'
			}),
			control: (provided, state) => ({
				...provided,
				height: 34,
				boxShadow: 0,
				borderRadius: 0
			}),
			menu: (provided, state) => ({
				...provided,
				marginTop: 0
			}),
			noOptionsMessage: (provided, state) => ({
				...provided,
				marginLeft: 0,
				height: 20,
				padding: 0,
				marging: 0
			})
		}

		return (
			<div className="arrow-combo">
				<Button {...buttonOpts} onClick={this._handlePreviousClick}>
					<Glyphicon glyph="arrow-left" />
				</Button>
				<Select {...selectOpts} styles={customStyles} ref={(select) => { this.select = select; }} />
				<Button {...buttonOpts} onClick={this._handleNextClick}>
					<Glyphicon glyph="arrow-right" />
				</Button>
			</div>
		)
	}
}

ArrowCombo.defaultProps = {
	formControl: true,
	managed: false,
	clearable: false
};

export default ArrowCombo;



// WEBPACK FOOTER //
// ./src/fw/forms/controls/arrowCombo/ArrowCombo.js